import { Button, Card, Descriptions, Typography, message } from 'antd';
import React, { memo } from 'react';

const { Title } = Typography;

/**
 * Component for displaying applicant contact information
 * @param {Object} props - Component props
 * @param {Object} props.data - Applicant data object
 */
const ContactInfo = memo(({ data }) => {
    if (!data) return null;

    return (
        <Card className="mb-4">
            <Descriptions title="Present Address" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                <Descriptions.Item label="House No.">{data.presentHouseNo || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Barangay">{data.presentBarangay || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="City">{data.presentCity || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Province">{data.presentProvince || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Postal Code">{data.presentPostalCode || 'N/A'}</Descriptions.Item>
            </Descriptions>

            {data.permanentHouseNo && (
                <div className="mt-4">
                    <Descriptions title="Permanent Address" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="House No.">{data.permanentHouseNo || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="Barangay">{data.permanentBarangay || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="City">{data.permanentCity || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="Province">{data.permanentProvince || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="Postal Code">{data.permanentPostalCode || 'N/A'}</Descriptions.Item>
                    </Descriptions>
                </div>
            )}

            {data.familyContacts && data.familyContacts.length > 0 && (
                <div className="mt-4">
                    <Title level={5}>Family Contacts</Title>
                    {data.familyContacts.slice(0, 2).map((contact, index) => (
                        <Descriptions
                            key={contact._id || index}
                            title={`${contact.relationship} - ${contact.firstName} ${contact.lastName}`}
                            bordered
                            column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
                            className="mt-2"
                        >
                            <Descriptions.Item label="Full Name">{`${contact.firstName} ${contact.middleName || ''} ${contact.lastName}`}</Descriptions.Item>
                            <Descriptions.Item label="Relationship">{contact.relationship}</Descriptions.Item>
                            <Descriptions.Item label="Occupation">{contact.occupation || 'N/A'}</Descriptions.Item>
                            <Descriptions.Item label="Mobile No.">{contact.mobileNo || 'N/A'}</Descriptions.Item>
                            <Descriptions.Item label="Email">{contact.emailAddress || 'N/A'}</Descriptions.Item>
                            <Descriptions.Item label="Emergency Contact">{contact.isEmergencyContact ? 'Yes' : 'No'}</Descriptions.Item>
                            <Descriptions.Item label="Address" span={2}>
                                {`${contact.houseNo || ''}, ${contact.city || ''}, ${contact.province || ''}, ${contact.country || ''}`}
                            </Descriptions.Item>
                        </Descriptions>
                    ))}
                    {data.familyContacts.length > 2 && (
                        <Button type="link" onClick={() => message.info(`There are ${data.familyContacts.length - 2} more contacts available.`)}>
                            View more contacts
                        </Button>
                    )}
                </div>
            )}
        </Card>
    );
});

export default ContactInfo;
